import React from 'react';
import { useDispatch } from 'react-redux';
import { fetchAccountEBPs } from '../../../actions/parent/accountConfigurations/fetch';
import AccountEBPsPage from '../../../components/body/parentSettings/configurations/AccountEBPsPage';

const AccountEBPsContainer: React.FC = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(fetchAccountEBPs());
  }, [dispatch]);

  return <AccountEBPsPage />;
};

export default AccountEBPsContainer;
